<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role == 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/"
                                                                       *ngIf="user.role == 'ROLE_ADMIN'">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Update Order</li>
    </ol>
  </nav>

  <div class="row ">

    <div class="inner-box ">

      <div class="row d-flex justify-content-between">
      <div class="form-group col-6">
        <label>Order no</label>
        <input type="text" id="orderNumber" onkeypress='return event.charCode >= 48 && event.charCode <= 57'
               [(ngModel)]="orderNumber" class="form-control" [ngModelOptions]="{standalone: true}"
               (blur)="orderNumberBlur()" [ngClass]="{'is-invalid':statusText1}" required placeholder="Enter Order Number">
      </div>


      <div class="col-6  mt-4">
        <button class="btn btn-danger float-end" (click)=submit()>update</button>
      </div>


      </div>


    </div>
  </div>
</section>



